export const isSellSupportApp = (): boolean => {
  if (typeof window === "undefined") return false;
  if (
    window.location.pathname.startsWith("/sale-support") ||
    window.location.pathname.startsWith("/sell-support") ||
    window.location.pathname.startsWith("/app2")
  ) {
    return true;
  }
  return false;
};

export const getAuthStorageKeys = () => {
  const sellSupport = isSellSupportApp();
  return {
    access: sellSupport ? "sellSupportAuthToken" : "authToken",
    refresh: sellSupport ? "sellSupportRefreshToken" : "refreshToken",
    loginPath: sellSupport ? "/sale-support/auth" : "/",
  };
};
